export function NoAccessCard() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "Arial, Helvetica, sans-serif",
        textAlign: "center",
        padding: "0 24px",
      }}
      id="login-box"
    >
      <img
        src="/dist/img/404-error.jpg"
        style={{ height: "150px", width: "150px", marginBottom: "24px" }}
        alt="No access"
      />
      <h3
        className="dark:text-foreground!"
        style={{ margin: 0, fontSize: "18px", fontWeight: 500, color: "#333" }}
      >
        Oops... you don't have access.
      </h3>
      <p
        className="dark:text-muted-foreground!"
        style={{ margin: "8px 0 0", fontSize: "14px", color: "#666" }}
      >
        Please contact your admin to get access.
      </p>
    </div>
  );
}
